export const extractTextFromQuill = (
  quillOps: { ops: any[] } | any[] | string | undefined,
): string => {
  if (!quillOps) {
    return '';
  }

  if (typeof quillOps === 'string') {
    return quillOps;
  }

  if (!Array.isArray(quillOps)) {
    return extractTextFromQuill(quillOps.ops);
  }

  return quillOps.reduce((acc, op) => {
    if (typeof op.insert === 'string') {
      return acc + op.insert;
    }

    return acc;
  }, '');
};

export const extractTextFromQuillTrimmed = (
  quillOps: { ops: any[] } | any[] | string | undefined,
): string => {
  return extractTextFromQuill(quillOps).trim();
};

export const extractUsedSearchParamsFromSection = (
  obj: Record<string, any>,
): string[] => {
  const searchParams = new Set<string>();

  const checkOp = (op: any): void => {
    const cvm = op?.insert?.['custom-value-mention'];
    if (
      cvm &&
      cvm.type === 'search-param' &&
      cvm.searchParam &&
      typeof cvm.searchParam === 'string'
    ) {
      searchParams.add(cvm.searchParam);
    }
  };

  // Helper function to traverse any value recursively
  const traverse = (value: any): void => {
    if (Array.isArray(value)) {
      // Recursively traverse each array element
      value.forEach(traverse);
    } else if (value && typeof value === 'object') {
      // Check if the object contains an "ops" array like in your original function
      if (Array.isArray(value.ops)) {
        value.ops.forEach(checkOp);
      }

      // Optionally, if the object itself is an op, check it as well.
      checkOp(value);

      // Recursively traverse every property of the object.
      Object.values(value).forEach(traverse);
    }
  };

  traverse(obj);
  return Array.from(searchParams);
};
